import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoindorecab() {



    const cardData = {

keyword: "Mumbai to Indore Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Indore Cab services for business travelers, families, tourists, pilgrims, corporate clients, and long-distance outstation passengers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth interstate journey. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, multi-city travel plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free and enjoyable road trip to Indore, the commercial capital of Madhya Pradesh, known for its royal heritage, vibrant food culture, historic landmarks, temples, and modern city attractions.",

topPlaces: [
    {
        title: "Rajwada Palace",
        description:
            "Rajwada Palace is one of Indore's most iconic landmarks and a symbol of the Holkar dynasty's rich heritage. Built more than two centuries ago, the seven-story structure combines Maratha, Mughal, and French architectural influences. Visitors admire its grand entrance, historical significance, beautifully restored interiors, and evening light shows that bring the palace's fascinating history to life. The palace remains one of the most visited attractions in Indore and provides a glimpse into the city's royal past."
    },
    {
        title: "Lal Bagh Palace",
        description:
            "Lal Bagh Palace is a magnificent royal residence that showcases the luxurious lifestyle of the Holkar rulers. The palace is famous for its grand halls, elegant European-style interiors, ornate chandeliers, marble decorations, and beautifully landscaped gardens. Visitors can explore the museum-like rooms and appreciate the architectural grandeur that makes this palace one of Indore's most treasured heritage attractions."
    },
    {
        title: "Khajrana Ganesh Temple",
        description:
            "Khajrana Ganesh Temple is one of the most revered religious destinations in Indore and attracts thousands of devotees every day. Dedicated to Lord Ganesha, the temple is known for its spiritual atmosphere, beautiful architecture, and strong religious significance. Devotees visit to seek blessings for prosperity, success, and happiness, making it an important pilgrimage stop during a Mumbai to Indore cab journey."
    },
    {
        title: "Sarafa Bazaar",
        description:
            "Sarafa Bazaar is one of India's most famous street food destinations and a must-visit attraction in Indore. During the day, it functions as a jewelry market, while at night it transforms into a vibrant food street offering local delicacies such as poha, jalebi, bhutte ka kees, garadu, and malpua. Visitors enjoy the lively atmosphere and authentic flavors that have made Indore a celebrated food capital."
    },
    {
        title: "Chappan Dukan",
        description:
            "Chappan Dukan, meaning Fifty-Six Shops, is another legendary food destination in Indore known for its wide variety of snacks, sweets, beverages, and local specialties. The area is always bustling with visitors enjoying famous Indori dishes and modern culinary offerings. It provides a perfect opportunity to experience the city's rich food culture and vibrant social atmosphere."
    },
    {
        title: "Kanch Mandir",
        description:
            "Kanch Mandir, also known as the Glass Temple, is a unique Jain temple decorated entirely with glass and mirrors. The intricate craftsmanship, reflective interiors, and spiritual ambiance make it one of Indore's most remarkable attractions. Visitors are fascinated by the artistic beauty and peaceful atmosphere of this architectural masterpiece."
    },
    {
        title: "Patalpani Waterfall",
        description:
            "Patalpani Waterfall is a stunning natural attraction located near Indore and is especially popular during the monsoon season. The waterfall cascades from a significant height into a scenic valley surrounded by lush greenery and rocky landscapes. Nature lovers, photographers, and adventure enthusiasts visit to enjoy the breathtaking scenery and refreshing environment."
    },
    {
        title: "Ralamandal Wildlife Sanctuary",
        description:
            "Ralamandal Wildlife Sanctuary is one of the oldest wildlife reserves in Madhya Pradesh and offers visitors an opportunity to experience nature close to the city. The sanctuary is home to deer, antelope, birds, and various plant species. Visitors enjoy trekking trails, wildlife observation, and panoramic views of the surrounding region from elevated viewpoints."
    },
    {
        title: "Annapurna Temple",
        description:
            "Annapurna Temple is a beautiful and spiritually significant temple dedicated to Goddess Annapurna. The temple is admired for its impressive entrance inspired by South Indian architecture, detailed carvings, and peaceful surroundings. Devotees and tourists visit to seek blessings while appreciating the temple's architectural elegance and religious importance."
    },
    {
        title: "Omkareshwar Jyotirlinga",
        description:
            "Located within driving distance from Indore, Omkareshwar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva and one of the most important pilgrimage destinations in India. Situated on an island shaped like the sacred Om symbol, the temple attracts devotees from across the country. Visitors experience spiritual serenity, scenic Narmada River views, and a deeply enriching religious atmosphere, making it an ideal addition to a Mumbai to Indore cab tour."
    }
],



services: [
{
name: "Mumbai to Indore Cab",
description: "Mumbai Airport Cab offers Mumbai to Indore Cab service for comfortable, safe, and affordable long-distance travel between Mumbai and Indore. Whether you are travelling for business meetings, corporate events, family vacations, educational tours, religious trips, personal travel, relocation, or group journeys, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, Force Urbania, and luxury vehicles. Our professional chauffeurs ensure a smooth interstate journey with doorstep pickup, flexible schedules, one way and round trip options, transparent pricing, and 24x7 booking support. We offer pickup services from Mumbai City, Mumbai Airport, Navi Mumbai, Thane, and nearby locations, ensuring a reliable and hassle-free travel experience to Indore with maximum comfort and convenience."
},
{
name: "Mumbai to Indore Taxi",
description: "Book Mumbai to Indore Taxi with Mumbai Airport Cab for reliable and convenient interstate transportation. Our experienced drivers, clean AC vehicles, affordable fares, and flexible travel options make every journey comfortable for families, business travellers, tourists, and corporate clients."
},
{
name: "Mumbai to Indore Taxi Fare",
description: "Get affordable Mumbai to Indore Taxi Fare with Mumbai Airport Cab. We provide transparent pricing, no hidden charges, multiple vehicle choices, and cost-effective travel packages for one way and round trip bookings."
},
{
name: "Mumbai to Indore Cab Fare",
description: "Mumbai Airport Cab offers competitive Mumbai to Indore Cab Fare with professional chauffeurs, premium vehicles, dependable service, and flexible travel plans suitable for all categories of travellers."
},
{
name: "Cab from Mumbai to Indore",
description: "Choose a Cab from Mumbai to Indore with Mumbai Airport Cab and enjoy safe, comfortable, and reliable transportation with experienced drivers and well-maintained AC vehicles for long-distance travel."
},
{
name: "Mumbai to Indore Car Rental",
description: "Book Mumbai to Indore Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, Tempo Traveller, and luxury vehicles for a comfortable, flexible, and enjoyable travel experience."
},
{
name: "Mumbai to Indore Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Indore Cab Booking with instant confirmation, 24x7 customer support, professional drivers, and multiple vehicle options suitable for individual, family, and corporate travel requirements."
},
{
name: "Mumbai to Indore One Way Cab",
description: "Travel conveniently with Mumbai to Indore One Way Cab service featuring fixed pricing, comfortable AC vehicles, professional chauffeurs, and hassle-free pickup and drop facilities for seamless travel."
},
{
name: "Mumbai to Indore Round Trip Cab",
description: "Mumbai Airport Cab provides Mumbai to Indore Round Trip Cab packages for business travel, family holidays, sightseeing tours, corporate transportation, and extended interstate journeys with flexible schedules."
},
{
name: "Mumbai to Indore Outstation Cab",
description: "Book Mumbai to Indore Outstation Cab for comfortable long-distance travel with premium vehicles, experienced drivers, affordable rates, customized travel packages, and reliable customer assistance."
},
{
name: "Mumbai to Indore Taxi Service",
description: "Mumbai Airport Cab offers Mumbai to Indore Taxi Service with safe transportation, clean AC vehicles, affordable pricing, professional chauffeurs, and dependable customer support throughout the journey."
},
{
name: "Mumbai to Indore Car Hire",
description: "Choose Mumbai to Indore Car Hire with Mumbai Airport Cab for premium chauffeur-driven transportation featuring comfortable seating, flexible schedules, personalized travel assistance, and excellent service quality."
},
{
name: "Mumbai to Indore SUV Cab",
description: "Mumbai Airport Cab provides Mumbai to Indore SUV Cab service for larger families, corporate teams, and groups seeking spacious interiors, premium comfort, superior road presence, and ample luggage capacity."
},
{
name: "Mumbai to Indore Innova Cab",
description: "Book Mumbai to Indore Innova Cab with Mumbai Airport Cab for spacious seating, premium comfort, professional chauffeur service, and reliable long-distance transportation for families and business travellers."
},
{
name: "Mumbai Airport to Indore Cab",
description: "Book Mumbai Airport to Indore Cab with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, professional chauffeurs, and comfortable AC vehicles for stress-free travel."
},
{
name: "Navi Mumbai to Indore Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Indore Cab service with doorstep pickup, affordable fares, premium vehicles, and reliable interstate transportation for business travellers, families, and tourists."
},
{
name: "Thane to Indore Cab",
description: "Choose Thane to Indore Cab with Mumbai Airport Cab for reliable transportation, professional drivers, comfortable vehicles, and flexible travel schedules designed for smooth and convenient travel."
},
{
name: "Mumbai to Indore Business Travel Cab",
description: "Mumbai Airport Cab provides Mumbai to Indore Business Travel Cab service specially designed for corporate executives, professionals, entrepreneurs, industrial visits, conferences, and official business transportation needs."
}
],

tableData: [
["Mumbai to Indore Cab","Mumbai to Indore Taxi"],
["Mumbai to Indore Taxi Fare","Mumbai to Indore Cab Fare"],
["Cab from Mumbai to Indore","Mumbai to Indore Car Rental"],
["Mumbai to Indore Cab Booking","Mumbai to Indore One Way Cab"],
["Mumbai to Indore Round Trip Cab","Mumbai to Indore Outstation Cab"],
["Mumbai to Indore Taxi Service","Mumbai to Indore Car Hire"],
["Mumbai to Indore SUV Cab","Mumbai to Indore Innova Cab"],
["Mumbai Airport to Indore Cab","Navi Mumbai to Indore Cab"],
["Thane to Indore Cab","Mumbai to Indore Business Travel Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Indore Cab Service",
WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Indore Cab transportation for business travelers, families, tourists, professionals, and long-distance travelers seeking a comfortable journey."
},
{
WhyChooseheading: "Convenient Interstate Travel Experience",
WhyChoosedescription: "Our cab service offers hassle-free connectivity between Mumbai and Indore for corporate travel, family visits, educational purposes, tourism, and relocation needs."
},
{
WhyChooseheading: "Perfect for Business and Commercial Travel",
WhyChoosedescription: "Indore is one of Central India's leading commercial cities, attracting professionals, entrepreneurs, and business travelers throughout the year."
},
{
WhyChooseheading: "Wide Range of Vehicle Options",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel requirements."
},
{
WhyChooseheading: "One-Way and Round Trip Booking",
WhyChoosedescription: "Whether you require a one-way transfer, round trip, multi-day travel, or customized itinerary, we provide flexible booking solutions."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Long-Distance Travel",
WhyChoosedescription: "Our experienced chauffeurs and regularly maintained vehicles ensure a safe, comfortable, and stress-free journey throughout the route."
},
{
WhyChooseheading: "Suitable for Families and Group Travelers",
WhyChoosedescription: "From solo travelers to large groups, we provide suitable vehicle options for vacations, corporate travel, family functions, and special occasions."
}
]
};

const faqData = [
{
question: "Why do travelers book Mumbai to Indore Cabs?",
answer: "Indore is a major commercial, educational, industrial, and tourist destination that attracts travelers for business, family visits, studies, and tourism."
},
{
question: "Can I book a one-way cab from Mumbai to Indore?",
answer: "Yes, one-way cab services are available along with round-trip and customized interstate travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Indore travel?",
answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are popular choices for comfortable long-distance travel."
},
{
question: "Do you provide round-trip packages for Indore?",
answer: "Yes, customers can choose round-trip and multi-day travel packages according to their travel requirements."
},
{
question: "Can business professionals use this service regularly?",
answer: "Yes, many executives, entrepreneurs, and corporate travelers use Mumbai Airport Cabs for business travel to Indore."
},
{
question: "Are Tempo Travellers available for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate teams, and group transportation."
},
{
question: "Can I get pickup from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
},
{
question: "Can multiple stops be added during the journey?",
answer: "Yes, customers can customize their itinerary and include sightseeing locations, business destinations, restaurants, and personal stops."
},
{
question: "Is advance booking recommended for Mumbai to Indore travel?",
answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel planning."
},
{
question: "How can I book a Mumbai to Indore Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rakesh Agrawal",
feedback:
"The journey from Mumbai to Indore was extremely comfortable and professionally managed. The vehicle was well-maintained and the driver ensured a smooth travel experience.",
rating: 5
},
{
id: 2,
name: "Mrs. Poonam Verma",
feedback:
"Mumbai Airport Cabs provided excellent service for our family trip to Indore. The cab was spacious, the pickup was punctual, and the overall experience was outstanding.",
rating: 5
}
];







































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Indore Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-indore-cab.jpg",
"description": "Book Mumbai to Indore cab service for safe, comfortable, and affordable long-distance travel. Mumbai Airport Cabs offers reliable taxi service from Mumbai, Navi Mumbai, Thane, and Mumbai Airport to Indore with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-indore-cab"
}
};









    return (
        <div>


<Helmet>
  <title>Mumbai to Indore Cab | Taxi Service & Fare | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Indore cab service at affordable fares. Reliable long-distance taxi service from Mumbai, Navi Mumbai, Thane, and Mumbai Airport to Indore with professional drivers and comfortable cars."
/>

<meta
 name="keywords"
 content="mumbai to indore cab, mumbai to indore taxi, mumbai to indore taxi fare, mumbai to indore cab fare, cab from mumbai to indore, mumbai to indore car rental, mumbai to indore cab booking, mumbai to indore one way cab, mumbai to indore round trip cab, mumbai to indore outstation cab, mumbai to indore taxi service, mumbai airport to indore cab, navi mumbai to indore cab, thane to indore cab, indore cab from mumbai, suv cab mumbai to indore, innova cab mumbai to indore"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoindorecab;